<template>
    <div style="background-color:white;" v-if="!loading">
        加载中。。。请稍后
    </div>
    
</template>
<script>
import MyEditor from "@/plugins/myEditor"
export default {
    components:{
        MyEditor
    },
    data(){
        return {
        }
    },
    created(){
        this.loading = true
        this.curUserNo = this.$userNo()
        document.title='通报'
        this.initData()
    },
    mounted(){
    },
    methods:{
        initData(){
            let guid = this.$route.query.guid
            this.$http.get('/api/job/v0.1/riskReport/getViewByGuid?guid='+guid)
            .then(res=>{
                
            })
        }
    }
}
</script>